<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmadd" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Reason:</label>
	<input
		[disabled]="IsLoading() == true"
		type="text"
		maxlength="50"
		class="form-control"
		[(ngModel)]="VisitorReasonDesc"
		placeholder="Enter Reason Description"
		style="width: 360px"
	/>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning leftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
